import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import LeftBarResume from "./LeftBarResume";
import RightBarResume from "./RightBarResume";
import TopBarRusme from "./TopBarRusme";

const Resume = () => {
  const [className, setClassName] = useState("resume");
  const { state } = useLocation();

  return (
    <div className="parent">
      <>
        <div className={className}>
          <TopBarRusme resume={state} />
          <div className="wrapper">
            <LeftBarResume resume={state} />
            <RightBarResume resume={state} setClassName={setClassName} />
          </div>
        </div>
      </>
      )}
    </div>
  );
};

export default Resume;
